/**
 * Som de notificação: URL e helpers de volume.
 * O MP3 é importado de assets para o Vite incluí-lo no build e evitar 404 em produção
 * (ex.: quando o app é servido em subpath ou CDN).
 */

// Import do asset garante URL correta em dev e produção (incluído no build)
import notificationSoundAsset from '../assets/notifica_o .mp3';
import internalChatSoundAsset from '../assets/notificao-1.mp3';

const STORAGE_VOLUME = 'volume';
const STORAGE_MUTED = 'notificationSoundMuted';

/** URL do áudio de notificação (sempre válida, pois vem do bundle). */
export function getNotificationSoundUrl() {
  return notificationSoundAsset;
}

/**
 * Som do chat interno (popover, widget, aviso de nova mensagem).
 * Mesmo padrão de `getNotificationSoundUrl`: asset no bundle (evita 404 com BASE_URL/subpath).
 */
export function getInternalChatNotificationSoundUrl() {
  return internalChatSoundAsset;
}

/**
 * Toca o som do chat interno com volume/mute do header (localStorage).
 */
export function playInternalChatNotificationSound() {
  try {
    if (isNotificationMuted()) return;
    const vol = getNotificationVolume();
    const audio = new Audio(getInternalChatNotificationSoundUrl());
    audio.volume = vol >= 0.99 ? 1 : vol;
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch (_err) {
    /* silencioso */
  }
}

/** Volume normalizado entre 0 e 1; padrão 1 se não definido. */
export function getNotificationVolume() {
  if (typeof window === 'undefined' || !window.localStorage) return 1;
  const raw = localStorage.getItem(STORAGE_VOLUME);
  const num = raw !== null && raw !== '' ? Number(raw) : NaN;
  return !Number.isFinite(num) ? 1 : Math.min(1, Math.max(0, num));
}

/** true se o som estiver mutado (volume no mínimo ou flag explícita). */
export function isNotificationMuted() {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  if (localStorage.getItem(STORAGE_MUTED) === 'true') return true;
  return getNotificationVolume() < 0.01;
}

/**
 * Toca o som de notificação com o volume atual do localStorage.
 * Respeita mute e volume; falha silenciosa para não quebrar o fluxo.
 */
export function playNotificationSound() {
  try {
    if (isNotificationMuted()) return;
    const vol = getNotificationVolume();
    const audio = new Audio(getNotificationSoundUrl());
    audio.volume = vol >= 0.99 ? 1 : vol;
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch (_err) {
    // Falha silenciosa para não impactar UX
  }
}
